import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=9f3a96e6&scoped=true"
import script from "./HomeHero.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHero.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3a96e6",
  null
  
)

export default component.exports